<script setup>
import Loading from '@/components/loading.vue';
import emptyCard from '@/components/emptyCard.vue';
import traitsCard from './component/traitsCard.vue'
import { get_packages, parsePackageswithCharacteristics } from '@/services/option';
import { ref, onMounted } from 'vue';

import { swalError } from '@/helper';

const isLoading = ref(true)
const current = ref({
  isOpen: false,
  package_id: ''
})
const packages_config = ref([])
onMounted(async ()=>{
  let packages_response = await get_packages()
  if (packages_response.error) {
    if (!packages_response.isRedirecting) swalError(packages_response.message || 'Failed to load packages')
    return
  }
  // console.log("🚀 ~ file: createAssessment.vue:18 ~ onMounted ~ packages_response:", packages_response)
  packages_config.value = await parsePackageswithCharacteristics(packages_response.result)
  // console.log("🚀 ~ file: createAssessment.vue:24 ~ onMounted ~ packages_config.value:", packages_config.value)
  
  isLoading.value = false
})

function calcTrait(characters){
  return characters.reduce((sum, obj) => sum + obj.traits.length, 0);
}

function getPackage(){
  return packages_config.value.find( packageObj => packageObj.id == current.value.package_id)
}

const wait = (n) => new Promise((resolve) => setTimeout(resolve, n));
async function openTraitCard(packageObj){
  if (current.value.isOpen){
    // close for 1 second and reopen a new card 
    // to get the animation
    current.value.isOpen = !current.value.isOpen
    await wait(500);
    
    current.value.isOpen = true
    current.value.package_id = packageObj.id
  }else{
    current.value.isOpen = true
    current.value.package_id = packageObj.id
  }
}

function closeTraitCard(){
  current.value.isOpen = !current.value.isOpen
}

</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Interventions" :mainRoute="{name: 'package-intervention-list'}"/>

    <Loading v-if="isLoading" />
    <div v-else class="row" v-auto-animate>
      <div v-auto-animate :class="{'col-12' : !current.isOpen, 'col-4': current.isOpen}">
        <template v-if="packages_config.length !== 0">
          <div v-auto-animate v-for="packageObj in packages_config" :key="packageObj.id" class="card mb-3">
            <div class="card-body row py-3">
              <div :class="{'col-6': current.isOpen, 'col-3': !current.isOpen}" class="d-flex align-items-center">
                <div>
                  <h6 class="mb-0">{{ packageObj.options.name.value }}</h6>
                </div>
              </div>
              <div v-if="!current.isOpen" class="col-6 d-flex justify-content-evenly align-items-center">
                <p class="my-auto">
                  <span>Min Value : </span>
                  <b>{{ packageObj.options.min.value }}</b>
                </p>
                <p class="my-auto">
                  <span>Max Value : </span>
                  <b>{{ packageObj.options.max.value }}</b>
                </p>
                <p class="my-auto">
                  <span>Total Traits : </span>
                  <b>{{ calcTrait(packageObj.characters) }}</b>
                </p>
              </div>
              <div :class="{'col-6 justify-content-end': current.isOpen, 'col-3': !current.isOpen}" class="d-flex align-items-center">
                <button v-if="!current.isOpen || current.package_id !== packageObj.id" class="btn btn-primary" 
                  @click="openTraitCard(packageObj)"
                >
                  View Intervention
                </button>
                <button v-if="current.package_id == packageObj.id && current.isOpen" 
                  class="btn btn-danger" @click="closeTraitCard()"
                >
                  Close Traits
                </button>
              </div>
            </div>
          </div>
        </template>
        
        <emptyCard v-else :link="{
          routerObj:{
            name: 'dna-report-report'
          },
          desc: 'Create a package',
          class: 'w-50',
          type: 'link'
        }"/>
      </div>
  
      <traitsCard
        v-if="current.isOpen"
        :package_config="getPackage()"
        class="col-8"
      />
    </div>
  </div>
</template>